import { observable } from "mobx";
/**
* RacingResultLine defines model for branch object information
*
* @typedef RacingResultLine
* @type {Object}
* @property {id} Id identifier
* @property {competitorName} Competitor Name of current racing result line
* @property {result} Result of current racing result line
* @property {raceCardNum} RaceCardNum of current racing result line
* @property {dividend} Dividend of current racing result line
* @property {divisor} Divisor of current racing result line
* @property {percentDeduction} PercentDeduction of current racing result line
* @property {withdrawnTime} WithdrawnTime of current racing result line
* @property {leagueId} LeagueId of current racing result line
* @property {eventId} EventId of current racing result line
* @property {rule4Deduction} Rule4Deduction of current league
* @property {favorite} Favorite of current racing result line
* @property {isWithdrawn} IsWithdrawn of current racing result line
* @property {masterLeagueId} MasterLeagueId of current racing result line
*/

export class RacingResultLine {
    id: string;
    competitorName: string;
    @observable result: number;
    raceCardNum: number;
    @observable dividend: number;
    @observable divisor: number;
    percentDeduction: number;
    withdrawnTime: Date;
    leagueId: string;
    eventId: string;
    rule4Deduction: string;
    favorite: string;
    isWithdrawn: boolean;
    masterLeagueId: string;

    constructor(data: RacingResultLine) {

        this.id = data.id;
        this.competitorName = data.competitorName;
        this.result = data.result;
        this.raceCardNum = data.raceCardNum;
        this.dividend = data.dividend;
        this.divisor = data.divisor;
        this.percentDeduction = data.percentDeduction;
        this.withdrawnTime = data.withdrawnTime;
        this.leagueId = data.leagueId;
        this.eventId = data.eventId;
        this.rule4Deduction = data.rule4Deduction;
        this.favorite = data.favorite;
        this.isWithdrawn = data.isWithdrawn;
        this.masterLeagueId = data.masterLeagueId;
    }
}
